<template>
  <div
    :class="['container', _isMobile() ? 'mobile' : '']"
    :style="{
      background: tenantConfig.homeBgColor,
      'background-image': 'url(' + tenantConfig.homeBg + ')',
      'background-repeat': tenantConfig.homeBgRepeat,
    }"
  >
    <Header2 v-if="tenantConfig.headerType == 2" id="header"/>
    <Header3 v-else-if="tenantConfig.headerType == 3" id="header"/>
    <Header v-else id="header"/>
    <div class="cms">
      <router-view />
    </div>
    <a-back-top />
    <Footer />
  </div>
</template>

<script>
import { mixinDevice } from "@/utils/mixin.js";
import Header from "@/components/header/Header";
import Header2 from "@/components/header/Header2";
import Header3 from "@/components/header/Header3";
import Footer from "@/components/footer/Footer";
export default {
  name: "CmdLayout",
  mixins: [mixinDevice],
  components: {
    Header,
    Header2,
    Header3,
    Footer,
  },
  data() {
    return {
      tenantConfig: {},
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
  },
};
</script>
<style>
a * {
  transition: all 0.1s ease;
}
</style>
<style lang="less" scoped>
.container {
  background: #f2f6f8;
  // padding-top: 90px;
  .cms {
    max-width: 1200px;
    margin: 20px auto 20px;
    padding: 20px;
    background: #ffffffd1;
    border-radius: 30px;
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
}
.mobile{
  .cms{
    padding: 0px;
  }
}
</style>